import { render, staticRenderFns } from "./UnsavedChangesModal.vue?vue&type=template&id=43efd7ed&scoped=true"
import script from "./UnsavedChangesModal.vue?vue&type=script&lang=js"
export * from "./UnsavedChangesModal.vue?vue&type=script&lang=js"
import style0 from "./UnsavedChangesModal.vue?vue&type=style&index=0&id=43efd7ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43efd7ed",
  null
  
)

export default component.exports